import React, { useState } from "react";
import BannerCard from "./BannerCard";
import "./BannerCarousel.css";

export default function BannerCarousel({
    banners = [],
    visibleItems = 1,
    onBannerClick
}) {

    const [currentPage, setCurrentPage] = useState(0);

    const totalPages = Math.ceil(banners.length / visibleItems);

    const startIndex = currentPage * visibleItems;

    const visibleBanners = banners.slice(
        startIndex,
        startIndex + visibleItems
    );

    function next() {

        if (currentPage < totalPages - 1) {

            setCurrentPage(currentPage + 1);

        }

    }

    function previous() {

        if (currentPage > 0) {

            setCurrentPage(currentPage - 1);

        }

    }

    return (
        <div className="banner-carousel-container">
            <span className="banner-carousel-title">Mais para si</span>
            <div className="banner-carousel">
                <div className="banner-carousel__content">
                    {visibleBanners.map((banner) => (
                        <BannerCard
                            key={banner.id}
                            banner={banner}
                            onClick={() => onBannerClick?.(banner)}
                        />
                    ))}
                </div>
                <div className="banner-carousel__navigation">
                    <button
                        disabled={currentPage === 0}
                        onClick={previous}
                    >
                        ←
                    </button>
                    <button
                        disabled={currentPage === totalPages - 1}
                        onClick={next}
                    >
                        →
                    </button>
                </div>
            </div>
        </div>
    );

}